var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgLookupDatasetRecords = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#31C4C0",
    d: "M3 6a3 3 0 0 1 3-3h12a3 3 0 0 1 3 3v12a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M5.25 7.5A1.5 1.5 0 0 1 6.75 6h8.625a1.5 1.5 0 0 1 1.5 1.5v4.162a.453.453 0 1 1-.907 0V9.447a.6.6 0 0 0-.593-.509H8.883v3.07h4.635a.45.45 0 1 1 0 .902H8.883v3.056h3.905a.454.454 0 0 1 0 .909h-4.06l-.052-.003H6.75a1.5 1.5 0 0 1-1.5-1.5zm2.733 1.438v3.07H6.15v-2.47a.6.6 0 0 1 .6-.6zM6.15 15.372V12.91h1.833v3.062H6.75a.6.6 0 0 1-.6-.6",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#EBFAF9",
    fillRule: "evenodd",
    d: "M14.814 16.445q.564.563 1.378.563a1.82 1.82 0 0 0 1.135-.388L19 18.293a.28.28 0 0 0 .209.082.28.28 0 0 0 .209-.082.28.28 0 0 0 .082-.21.28.28 0 0 0-.082-.208l-1.673-1.673a1.82 1.82 0 0 0 .388-1.135q0-.814-.563-1.378a1.87 1.87 0 0 0-1.378-.564q-.814 0-1.378.564a1.87 1.87 0 0 0-.564 1.378q0 .813.564 1.378m2.33-.426a1.3 1.3 0 0 1-.952.392q-.56 0-.953-.392a1.3 1.3 0 0 1-.392-.952q0-.56.393-.953.39-.391.952-.392.56 0 .952.393.392.39.392.952 0 .56-.392.952",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgLookupDatasetRecords);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/lookup-dataset-records.02799da4.svg";